import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'
import * as COMMON from './common.res.js'


export const ioarea_fields = 'msecstamp,minp,maxp,obidm,ibidm,oaskm,iaskm'
export const iodate_fields = 'msec,agop,open,maxp,minp,newp,sumv,summ,obidm,ibidm,oaskm,iaskm'

// export const iominute_fields = 'msec,open,maxp,minp,newp,sumv,summ,oaskm,iaskm,obidm,ibidm'
// export const ftrend_fields = 'msecstamp,midp,stoped,near_upsf,near_dnsf,mood_upbf,mood_dnbf,mood_sumf,emny_summ,ep_seejgf,ep_seeshf,ep_seerzf'

// 字段定义
const FIELD_KBAR = {
    date: 0,
    agop: 1,
    open: 2,
    maxp: 3,
    minp: 4,
    newp: 5,
    sumv: 6,
    summ: 7,
    avgp: 8, // 60日均线
    clr: 9,
    right: 10,
}

export function concatKbar(curbar, nowbar) {
    const newbar = {
        fields: DATAS.fieldsToFieldsIndex(COMMON.newbar_fields),
        datas: [nowbar.infos]
    }
    console.log(newbar);
    
    const newbarMsec = CLAPI.Utils.strMsecToMTime(CLAPI.getData(newbar, 'msecstamp', 0))
    const curbarMsec = CLAPI.getData(curbar, 'msec', -1);
    if (newbarMsec > curbarMsec) {
        curbar.datas.push([
            CLAPI.Utils.strMsecToMTime(CLAPI.getData(newbar, 'msecstamp', 0)),
            CLAPI.getData(newbar, 'agop', 0),
            CLAPI.getData(newbar, 'open', 0),
            CLAPI.getData(newbar, 'maxp', 0),
            CLAPI.getData(newbar, 'minp', 0),
            CLAPI.getData(newbar, 'newp', 0),
            CLAPI.getData(newbar, 'sumv', 0),
            CLAPI.getData(newbar, 'summ', 0),
            0,0,0,0
        ])
    }
}

export function IodateToAvgKbar(indata, keyWord, days) {
    let kbars = []
    days = days || 60
    // for (let index = indata.datas.length - 10; index < indata.datas.length; index++) {
    //     console.log(keyWord.frights[index][0], keyWord.frights[index][1]);
    // }
    let agoright = 0
    for (let index = 0; index < indata.datas.length; index++) {
        let right = '0'
        let clr = 'red'
        if (parseFloat(CLAPI.getData(indata, 'open', index)) > parseFloat(CLAPI.getData(indata, 'newp', index))) {
            clr = 'green'
        }
        let sumv = 0
        let summ = 0
        let avgp = CLAPI.getData(indata, 'newp', index)
        for (let di = index, ds = 0; di >= 0 && ds < days; di--, ds++) {
            sumv += CLAPI.getData(indata, 'sumv', index - ds)
            summ += CLAPI.getData(indata, 'summ', index - ds)
        }
        avgp = summ / sumv
        // if (index > indata.datas.length - 10)
        // console.log(CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)), right, keyWord.frights[index][1], agoright);
        if (keyWord.frights && keyWord.frights[index] !== undefined) {
            if (index > 0) {
                if (agoright !== keyWord.frights[index][1]) {
                    right = 'scir'
                }
            }
            agoright = keyWord.frights[index][1]
        }
        kbars.push(
            [CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)),
                CLAPI.getData(indata, 'agop', index),
                CLAPI.getData(indata, 'open', index),
                CLAPI.getData(indata, 'maxp', index),
                CLAPI.getData(indata, 'minp', index),
                CLAPI.getData(indata, 'newp', index),
                CLAPI.getData(indata, 'sumv', index),
                CLAPI.getData(indata, 'summ', index),
                avgp,
                clr,
                right,
            ])
    }
    return {
        fields: FIELD_KBAR,
        datas: kbars
    }
}

// {static  frights}
export function KbarExright(indata, keyWord, rightMode, days) {
    let kbars = []
    days = days || 60
    rightMode = rightMode || 'forword'
    // console.log(keyWord);
    for (let index = 0; index < indata.datas.length; index++) {
        // console.log(CLAPI.getData(indata, 'date', index), keyWord.frights[index][0], keyWord.frights[index][1]);
        let fr = keyWord.frights[index]
        if (index >= keyWord.frights.length) {
            fr = [0, 1.0]
        }
        kbars.push(
            [CLAPI.getData(indata, 'date', index),
                CLAPI.getData(indata, 'agop', index) * fr[1],
                CLAPI.getData(indata, 'open', index) * fr[1],
                CLAPI.getData(indata, 'maxp', index) * fr[1],
                CLAPI.getData(indata, 'minp', index) * fr[1],
                CLAPI.getData(indata, 'newp', index) * fr[1],
                CLAPI.getData(indata, 'sumv', index) / fr[1],
                CLAPI.getData(indata, 'summ', index),
                0,
                CLAPI.getData(indata, 'clr', index),
                CLAPI.getData(indata, 'right', index) !== '0' ? 'fcir' : '0',
            ])
        let sumv = 0
        let summ = 0
        for (let di = kbars.length - 1, ds = 0; di >= 0 && ds < days; di--, ds++) {
            sumv += kbars[di][6]
            summ += kbars[di][7]
        }
        kbars.at(-1)[8] = summ / sumv
    }
    return {
        fields: FIELD_KBAR,
        datas: kbars
    }
}

const FIELD_DDTJ = {
    date: 0,
    cur_summ: 1,
    big_askm: 2,
    big_bidm: 3,
    cur_bigm: 4,
    big_askr: 5,
    big_bidr: 6,
    cur_bigr: 7,
    sum_bigr5: 8,
}

export function IodateToDDTJ(indata, axisXinfo) {
    let outs = []    
    let cursor = 0
    function getIndex(currdate) {
        for (let index = cursor; index < indata.datas.length; index++) {
            const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
            if (curdate == currdate) {
                return index;
            }
        }
        return -1
    }
    const opendate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', 0))
    for (let axindex = 0; axindex < axisXinfo.length; axindex++) {
        if (opendate > axisXinfo[axindex]) {
            outs.unshift([axisXinfo[axindex], 0, 0, 0, 0, 0, 0, 0, 0])
            continue;
        }
        const index = getIndex(axisXinfo[axindex])
        if (index === -1) {
            outs.push([...outs[outs.length - 1]]); 
        }
        else {
            cursor = index
            const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
            let big_askm = 0
            let big_bidm = 0
            for (let mi = 3; mi < 8; mi++) {
                big_askm += CLAPI.getData(indata, 'oaskm' + mi.toString(), index)
                big_askm += 0.5 * CLAPI.getData(indata, 'iaskm' + mi.toString(), index)
                big_bidm += CLAPI.getData(indata, 'obidm' + mi.toString(), index)
                big_bidm += 0.5 * CLAPI.getData(indata, 'ibidm' + mi.toString(), index)
            }
            const cur_bigm = big_bidm - big_askm
            const cur_summ = CLAPI.getData(indata, 'summ', index)

            outs.push(
                [curdate,
                    cur_summ,
                    big_askm,
                    big_bidm,
                    cur_bigm,
                    big_askm / cur_summ,
                    big_bidm / cur_summ,
                    cur_bigm / cur_summ,
                    0,
                ])
            let sum_bigm5 = 0
            let sum_summ5 = 0
            for (let bri = outs.length - 1, nums = 0; nums < 5 && bri >= 0; bri--, nums++) {
                sum_bigm5 += outs[bri][4]
                sum_summ5 += outs[bri][1]
            }
            outs[outs.length - 1][8] = sum_bigm5 / sum_summ5
        }
    }
    return {
        fields: FIELD_DDTJ,
        datas: outs
    }
}
const FIELD_MMQD = 'date,maskm,mbidm,mbigm,maskr,mbidr,msubr,paskm,pbidm,paskr,pbidr,psubr,mambr,mamsr,mamcr,mapbr,mapsr,mapcr'

export function rpmToMMQD(indata, axisXinfo) {
    let outs = []
    let cursor = 0
    function getIndex(currdate) {
        for (let index = cursor; index < indata.datas.length; index++) {
            const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
            // console.log(index, indata.datas.length, curdate, currdate);
            if (curdate === currdate) {
                return index;
            }
        }
        return -1
    }
    const opendate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', 0))
    for (let axindex = 0; axindex < axisXinfo.length; axindex++) {
        if (axisXinfo[axindex] < opendate) {
            outs.unshift([axisXinfo[axindex], 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,])
            continue;
        }
        const index = getIndex(axisXinfo[axindex])
        // console.log(index, axisXinfo[axindex]);
        
        if (index === -1) {
            outs.push([...outs[outs.length - 1]]); 
        }
        else {
            cursor = index
            let maskm = 0
            let mbidm = 0
            let paskm = 0
            let pbidm = 0
            for (let mi = 0; mi < 8; mi++) {
                maskm += CLAPI.getData(indata, 'moaskm' + mi.toString(), index)
                mbidm += CLAPI.getData(indata, 'mobidm' + mi.toString(), index)
            }
            for (let mi = 0; mi < 9; mi++) {
                paskm += CLAPI.getData(indata, 'poaskm' + mi.toString(), index)
                pbidm += CLAPI.getData(indata, 'pobidm' + mi.toString(), index)
            }
            const summny = CLAPI.getData(indata, 'summ', index)
            let maskr = maskm / summny
            let mbidr = mbidm / summny
            let paskr = paskm / summny
            let pbidr = pbidm / summny
            const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
            outs.push(
                [curdate,
                    maskm,
                    mbidm,
                    mbidm - maskm,
                    maskr,
                    mbidr,
                    mbidr - maskr,
                    paskm,
                    pbidm,
                    paskr,
                    pbidr,
                    pbidr - paskr,
                    0, 0, 0, 0, 0
                ])
        }
    }
    // console.log(axisXinfo, outs);
    
    function insertSorted(arr, val) {
        let idx = arr.findIndex(item => item > val);
        if(idx === -1){
            arr.push(val);
        }else{
            arr.splice(idx, 0, val);
        }
    }
    function normalizeByArray(arr, val) {
        const minVal = arr[0];
        const maxVal = arr.at(-1);
        const range = maxVal - minVal;
        if (range === 0) {
            // 数组全部元素相同，避免除0
            return 0;
        }
        return (val - minVal) / range;
    }
    function interpNormalize(arr, x) {
        const n = arr.length;
        if(n <= 1) return 0;
        const v0 = arr[0];
        const vn = arr.at(-1);
        if(x <= v0) return 0;
        if(x >= vn) return 1;

        //二分找插入位置
        let low = 0, high = n;
        while(low < high){
            const mid = Math.floor((low+high)/2);
            if(arr[mid] < x) low = mid+1;
            else high = mid;
        }
        const idx = low;
        const left = arr[idx-1];
        const right = arr[idx];
        //原区间插值
        const t = (x - left) / (right - left);
        //映射到全局0‑1
        const tLeft = (left - v0)/(vn - v0);
        const tRight = (right - v0)/(vn - v0);
        return tLeft + t * (tRight - tLeft);
    }
    // console.log(outs);
    let mambr = []
    let mamsr = []
    let mapbr = []
    let mapsr = []

    // let first = 0
    // for (let index = 0; index < outs.length; index++) {
    //     if (outs[index][1] > 0) {
    //         if (first === 0) {
    //             first = index
    //         }
    //         insertSorted(mambr, outs[index][4])
    //         insertSorted(mamsr, outs[index][3])
    //         insertSorted(mapbr, outs[index][9])
    //         insertSorted(mapsr, outs[index][8])
    //     }
    // }
    // for (let index = first; index < outs.length; index++) {
    //     outs[index][11] = interpNormalize(mambr, outs[index][4])
    //     outs[index][12] = interpNormalize(mamsr, outs[index][3])
    //     outs[index][13] = outs[index][11] - outs[index][12]
    //     outs[index][14] = interpNormalize(mapbr, outs[index][9])
    //     outs[index][15] = interpNormalize(mapsr, outs[index][8])
    //     outs[index][16] = outs[index][14] - outs[index][15]
    // }

    const madays = 60
    for (let index = madays; index < outs.length; index++) {
        mambr = []
        mamsr = []
        mapbr = []
        mapsr = []
        for (let step = index; step >= index - madays; step--) {
            insertSorted(mambr, outs[step][4])
            insertSorted(mamsr, outs[step][3])
            insertSorted(mapbr, outs[step][9])
            insertSorted(mapsr, outs[step][8])        
        }
        outs[index][11] = interpNormalize(mambr, outs[index][4])
        outs[index][12] = interpNormalize(mamsr, outs[index][3])
        outs[index][13] = outs[index][11] - outs[index][12]
        outs[index][14] = interpNormalize(mapbr, outs[index][9])
        outs[index][15] = interpNormalize(mapsr, outs[index][8])
        outs[index][16] = outs[index][14] - outs[index][15]
    }
    // console.log(outs);
    
    return {
        fields: DATAS.fieldsToFieldsIndex(FIELD_MMQD),
        datas: outs
    }
}
const FIELD_SHCC = {
    date: 0,
    xvolr: 1,
    yvolr: 2,
    zvolr: 3,
    smveer: 4,
    swveer: 5,
    dvolr: 6,
    xsvrchg: 7,
    ysvrchg: 8,
    zsvrchg: 9,
    dsvrchg: 10,
    bsflag: 11,
}
export function chip3ToSHCC(indata, axisXinfo) {
    let outs = []
    let agoxvolr = CLAPI.getData(indata, 'sumchip_volr0', 0)
    let cursor = 0
    function getIndex(currdate) {
        for (let index = cursor; index < indata.datas.length; index++) {
            const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
            if (curdate == currdate) {
                return index;
            }
        }
        return -1
    }
    const opendate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', 0))
    for (let axindex = 0; axindex < axisXinfo.length; axindex++) {
        if (opendate > axisXinfo[axindex]) {
            outs.unshift([axisXinfo[axindex], 0, 0, 0, 0, 0, 0, 0, 0, '0'])
            continue;
        }
        const index = getIndex(axisXinfo[axindex])
        if (index === -1) {
            outs.push([...outs[outs.length - 1]]); 
        }
        else {
            cursor = index
            const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
            
            let xvolr = CLAPI.getData(indata, 'sumchip_volr0', index)
            let xvchg = CLAPI.getData(indata, 'svrchg0', index)
            let bsflag = '0'
            const cutr = xvolr - agoxvolr
            if (cutr > 0.01 && CLAPI.getData(indata, 'newp', index) > CLAPI.getData(indata, 'agop', index)) {
                bsflag = 'ask'
            }
            if (cutr < -0.01 && CLAPI.getData(indata, 'newp', index) < CLAPI.getData(indata, 'agop', index)) {
                bsflag = 'bid'
            }
            agoxvolr = xvolr
            outs.push([curdate,
                    xvolr,
                    CLAPI.getData(indata, 'sumchip_volr1', index),
                    CLAPI.getData(indata, 'sumchip_volr2', index),
                    CLAPI.getData(indata, 'smveer', index),
                    CLAPI.getData(indata, 'swveer', index),
                    (1.0 - xvolr),
                    xvchg,
                    CLAPI.getData(indata, 'svrchg1', index),
                    CLAPI.getData(indata, 'svrchg2', index),
                    -1 * xvchg,
                    bsflag,
                ])
        }
    }
    // console.log(outs);
    
    return {
        fields: FIELD_SHCC,
        datas: outs
    }
}

const FIELD_CCCB = {
    date: 0,
    xsump: 1,
    ysump: 2,
    zsump: 3,
    xreap: 4,
    yreap: 5,
    zreap: 6,
    summaxv : 7,
    xreapr: 8,
    yreapr: 9,
    zreapr: 10,
}
export function chip3ToCCCB(indata, axisXinfo) {
    let outs = []
    let prerecs = []
    // let maxp = 0
    // let minp = 10000
    // let maxr = 0
    // let minr = 100000000000
    let cursor = 0
    function getIndex(currdate) {
        for (let index = cursor; index < indata.datas.length; index++) {
            const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
            if (curdate == currdate) {
                return index;
            }
        }
        return -1
    }
    const opendate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', 0))
    for (let axindex = 0; axindex < axisXinfo.length; axindex++) {
        if (opendate > axisXinfo[axindex]) {
            prerecs.push(axisXinfo[axindex])
            continue;
        }
        const index = getIndex(axisXinfo[axindex])
        if (index === -1) {
            outs.push([...outs[outs.length - 1]]); 
        }
        else {
            cursor = index
            const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
            const summaxv = CLAPI.getData(indata, 'sumchip_maxv0', index)
                    + CLAPI.getData(indata, 'sumchip_maxv1', index)
                    + CLAPI.getData(indata, 'sumchip_maxv2', index)
            const sumchip_sump0 = CLAPI.getData(indata, 'sumchip_sump0', index)
            const sumchip_sump1 = CLAPI.getData(indata, 'sumchip_sump1', index)
            const sumchip_sump2 = CLAPI.getData(indata, 'sumchip_sump2', index)
            const sumchip_reap0 = CLAPI.getData(indata, 'sumchip_reap0', index)
            const sumchip_reap1 = CLAPI.getData(indata, 'sumchip_reap1', index)
            const sumchip_reap2 = CLAPI.getData(indata, 'sumchip_reap2', index)
            // maxp = Math.max(maxp, sumchip_sump0, sumchip_sump1, sumchip_sump2)
            // minp = Math.min(minp, sumchip_sump0, sumchip_sump1, sumchip_sump2)
            // maxr = Math.max(maxr, sumchip_reap0, sumchip_reap1, sumchip_reap2)
            // minr = Math.min(minr, sumchip_reap0, sumchip_reap1, sumchip_reap2)
            if (prerecs.length > 0) {
                for (let si = 0; si < prerecs.length; si++) {
                    outs.push([prerecs[si], 
                        sumchip_sump0,
                        sumchip_sump1,
                        sumchip_sump2,
                        sumchip_reap0,
                        sumchip_reap1,
                        sumchip_reap2,
                        summaxv, 0, 0, 0,
                    ])                   
                }
                prerecs = []
            }
            outs.push([
                    curdate,
                    sumchip_sump0,
                    sumchip_sump1,
                    sumchip_sump2,
                    sumchip_reap0,
                    sumchip_reap1,
                    sumchip_reap2,
                    summaxv, 0, 0, 0,
                ])
        }
    }
    // console.log(outs);
    
    return {
        fields: FIELD_CCCB,
        datas: outs
    }
}

export const FIELD_KBAR_DXQL = {
    date: 0,
    nums: 1,
}
export function signalToDXQL(indata, axisXinfo) {
    let snums = []
    let index = 0
    let signal = {}
    for (let sindex = 0; sindex < indata.datas.length; sindex++) {
        const sdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msecstamp', sindex))
        if (signal[sdate] == undefined) {
            signal[sdate] = { nums : CLAPI.getData(indata, 'signal', sindex)}
        }
        else {
            signal[sdate].nums += CLAPI.getData(indata, 'signal', sindex)
        }
    }
    for (let axindex = 0; axindex < axisXinfo.length; axindex++) {
        const kdate = axisXinfo[axindex]
        if (signal[kdate] == undefined) {
            snums.push([kdate, 0])
        }
        else {
            snums.push([kdate, signal[kdate].nums])
        }
    }
    return {
        fields: FIELD_KBAR_DXQL,
        datas: snums
    }
}
// 浮动窗口信息
export const FIELD_KBAR_FWIN = {
    date: 0,
    agop: 1,
    open: 2,
    maxp: 3,
    minp: 4,
    newp: 5,
    sumv: 6,
    summ: 7,
    wave: 8,
    rate: 9,
}

export function curdateToFwin(curdata) {
    const indata = {
        datas: curdata,
        fields: FIELD_KBAR
    }
    const wave = (CLAPI.getData(indata, 'maxp', 0) - CLAPI.getData(indata, 'minp', 0)) / CLAPI.getData(indata, 'minp', 0)
    const rate = (CLAPI.getData(indata, 'newp', 0) - CLAPI.getData(indata, 'agop', 0)) / CLAPI.getData(indata, 'agop', 0)
    let kbars = [
        CLAPI.getData(indata, 'date', 0),
        CLAPI.getData(indata, 'agop', 0),
        CLAPI.getData(indata, 'open', 0),
        CLAPI.getData(indata, 'maxp', 0),
        CLAPI.getData(indata, 'minp', 0),
        CLAPI.getData(indata, 'newp', 0),
        CLAPI.getData(indata, 'sumv', 0),
        CLAPI.getData(indata, 'summ', 0),
        wave, rate
    ]
    return {
        fields: FIELD_KBAR_FWIN,
        datas: kbars
    }
}



// // 日线到周线
// /**
//  * convert day data to week data
//  * @export
//  * @param {Array} daydata
//  * @return {Array}
//  */
// export function matchDayToWeek (daydata) {
//   const out = []
//   const zipday = []

//   const field = FIELD_DATE
//   let isBegin = true
//   for (let k = 0; k < daydata.length; k++) {
//     if (isBegin) {
//       zipday[field.open] = daydata[k][field.open]
//       zipday[field.high] = daydata[k][field.high]
//       zipday[field.low] = daydata[k][field.low]
//       isBegin = false
//     } else {
//       zipday[field.high] = zipday[field.high] > daydata[k][field.high]
//         ? zipday[field.high] : daydata[k][field.high]
//       zipday[field.low] = zipday[field.low] < daydata[k][field.low] || daydata[k][field.low] === 0
//         ? zipday[field.low] : daydata[k][field.low]
//     }
//     zipday[field.close] = daydata[k][field.close]
//     zipday[field.vol] = daydata[k][field.vol]
//     zipday[field.money] = daydata[k][field.money]

//     // 周五 or 下一个日期跨越一周
//     const week = getDayWeek(daydata[k][field.time])
//     if (k >= daydata.length - 1 || week === 5 ||
//       (getDayGap(daydata[k][field.time], daydata[k + 1][field.time]) + week > 7)) {
//       zipday[field.time] = daydata[k][field.time]
//       out.push(copyArrayOfDeep(zipday))
//       isBegin = true
//     }
//   } // for i
//   if (!isBegin) {
//     zipday[field.time] = daydata[daydata.length - 1][field.time]
//     out.push(copyArrayOfDeep(zipday))
//   }
//   return out
// }

// // 日线到月线
// /**
//  * convert day data to month data
//  * @export
//  * @param {Array} daydata
//  * @return {Array}
//  */
// export function matchDayToMon (daydata) {
//   let month
//   const out = []
//   const zipday = []

//   const field = FIELD_DATE
//   let isBegin = true
//   for (let k = 0; k < daydata.length; k++) {
//     if (isBegin) {
//       zipday[field.open] = daydata[k][field.open]
//       zipday[field.high] = daydata[k][field.high]
//       zipday[field.low] = daydata[k][field.low]
//       month = getDayMon(daydata[k][field.time])
//       isBegin = false
//     } else {
//       zipday[field.high] = zipday[field.high] > daydata[k][field.high]
//         ? zipday[field.high] : daydata[k][field.high]
//       zipday[field.low] = zipday[field.low] < daydata[k][field.low] || daydata[k][field.low] === 0
//         ? zipday[field.low] : daydata[k][field.low]
//     }
//     zipday[field.close] = daydata[k][field.close]
//     zipday[field.vol] = daydata[k][field.vol]
//     zipday[field.money] = daydata[k][field.money]

//     if (k >= daydata.length - 1 || getDayMon(daydata[k + 1][field.time]) !== month) {
//       zipday[field.time] = daydata[k][field.time]
//       out.push(copyArrayOfDeep(zipday))
//       isBegin = true
//     }
//   } // for i
//   if (!isBegin) {
//     zipday[field.time] = daydata[daydata.length - 1][field.time]
//     out.push(copyArrayOfDeep(zipday))
//   }
//   return out
// }
